import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL, getDimension } = useContext(Context);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/product/${id}`);
    reset(response?.data);
    console.log(response?.data);

    // setValue("promotional_products_status", response?.data?.promotional_products_status ? 1 : 0);
    // setValue("sustainable_products_status", response?.data?.sustainable_products_status ? 1 : 0);
    // setImagePreview(IMG_URL + response?.data?.image);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    watch,
    setValue,
  } = useForm();
  const watchSortOrder = watch("sort_order");
  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append(
        "sustainable_products_status",
        data?.sustainable_products_status ? 1 : 0
      );
      sendData.append(
        "promotional_products_status",
        data?.promotional_products_status ? 1 : 0
      );
      sendData.append(
        "partnership_products_status",
        data?.partnership_products_status ? 1 : 0
      );
      sendData.append("image1", data?.image1[0]);
      sendData.append("sort_order", data?.sort_order);
      const response = await postData(
        `/masters/product-type/sustainable/${id}`,
        sendData
      );
      console.log(response);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const imageFile = watch("image1");

  // const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setImageFile([file]);
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setImagePreview(reader.result); // Set image preview
  //     };
  //     reader.readAsDataURL(file);
  //   } else {
  //     setImageFile(null);
  //   }
  // };
  // const isPromoChecked = watch("promotional_products_status");
  // const isSustainableChecked = watch("sustainable_products_status");
  // useEffect(() => {
  //   setValue("promotional_products_status", isPromoChecked ? 1 : 0);
  // }, [isPromoChecked, setValue]);

  // useEffect(() => {
  //   setValue("sustainable_products_status", isSustainableChecked ? 1 : 0);
  // }, [isSustainableChecked, setValue]);
  let expectedWidth = null;
  let expectedHeight = null;

  const sortOrder = Number(watchSortOrder);

  if ([2, 3, 4, 5, 7, 8, 9, 10].includes(sortOrder)) {
    expectedWidth = 413;
    expectedHeight = 413;
  } else if ([1, 6].includes(sortOrder)) {
    expectedWidth = 850;
    expectedHeight = 850;
  }
  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Product
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="justify-content-center">
              <Row>
                <Col md={6}>
                  <div className="main-form-section my-3">
                    <Row className="justify-content-center">
                      <Form.Group>
                        <Form.Check
                          type="checkbox"
                          label="Sustainable Product Status"
                          name="sustainable_products_status"
                          className={classNames("", {
                            "is-invalid": errors?.sustainable_products_status,
                          })}
                          {...register("sustainable_products_status")}
                        />
                        {errors.sustainable_products_status && (
                          <span className="text-danger">
                            {errors.sustainable_products_status.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="main-form-section my-3">
                    <Row className="justify-content-center">
                      <Form.Group>
                        <Form.Check
                          type="checkbox"
                          label="Promotional Product Status"
                          name="promotional_products_status"
                          className={classNames("", {
                            "is-invalid": errors?.promotional_products_status,
                          })}
                          {...register("promotional_products_status")}
                        />
                        {errors.promotional_products_status && (
                          <span className="text-danger">
                            {errors.promotional_products_status.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="main-form-section my-3">
                    <Row className="justify-content-center">
                      <Form.Group>
                        <Form.Check
                          type="checkbox"
                          label="Partnership Product Status"
                          name="partnership_products_status"
                          className={classNames("", {
                            "is-invalid": errors?.partnership_products_status,
                          })}
                          {...register("partnership_products_status")}
                        />
                        {errors.partnership_products_status && (
                          <span className="text-danger">
                            {errors.partnership_products_status.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Col md={6}>
                <div className="main-form-section my-3">
                  <Form.Group>
                    <div className="text-center">
                      <Form.Label>Sort Order</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        name="name"
                        placeholder="Sort Order"
                        className={classNames("", {
                          "is-invalid": errors?.sort_order,
                        })}
                        {...register("sort_order", {
                          required: "sort_order is required",
                        })}
                      />
                    </InputGroup>
                    {errors.sort_order && (
                      <span className="text-danger">
                        {errors.sort_order.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section my-3">
                  <Form.Label>Image</Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.image1,
                      })}
                      type="file"
                      multiple
                      {...register("image1", {
                        required: getValues("image1")
                          ? false
                          : "Images is required",
                        validate: async (value) => {
                          if (typeof value !== "string") {
                            const fileTypes = ["jpg", "png", "jpeg"];
                            const fileType = value[0].name?.split(".")[1];

                            if (!fileTypes.includes(fileType)) {
                              return `please upload a valid file format. (${fileTypes})`;
                            }
                            const sizes = await getDimension(value[0]);
                            const sortOrder = Number(getValues("sort_order"));

                            let expectedWidth = null;
                            let expectedHeight = null;

                            // Define dimensions based on sort_order
                            if ([2, 3, 4, 5].includes(sortOrder)) {
                              expectedWidth = 413;
                              expectedHeight = 413;
                            } else if (sortOrder === 1) {
                              expectedWidth = 850;
                              expectedHeight = 850;
                            }

                            if (expectedWidth && expectedHeight) {
                              if (
                                sizes.width !== expectedWidth ||
                                sizes.height !== expectedHeight
                              ) {
                                return `Image dimensions must be ${expectedWidth}px × ${expectedHeight}px for sort order ${sortOrder}`;
                              }
                            }
                          }
                        },
                      })}
                      accept="image/*"
                    />
                  </Form.Group>
                  {expectedWidth && expectedHeight && (
                    <span className="text-danger">
                      Image dimensions must be {expectedWidth}px ×{" "}
                      {expectedHeight}px for Sort Order {sortOrder}
                    </span>
                  )}
                  {/* {errors.image1 && (
                    <span className="text-danger">{errors.image1.message}</span>
                  )} */}
                </div>
              </Col>
              <Col lg={3}>
                <div className="main-form-section my-3">
                  <Form.Label>Image Preview</Form.Label>

                  {typeof getValues("image1") == "string" ? (
                    <div className="image-preview-container">
                      <img
                        src={IMG_URL + getValues("image1")}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "150px", height: "130px" }}
                      />
                    </div>
                  ) : (
                    imageFile &&
                    imageFile?.length > 0 && (
                      <div className="image-preview-container">
                        <img
                          // src={URL.createObjectURL(getValues("image")[0])}
                          src={URL?.createObjectURL(imageFile[0])}
                          alt="Preview"
                          className="image-preview"
                          style={{ width: "100px", height: "100px" }}
                        />
                      </div>
                    )
                  )}
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
